import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { groupBy, mergeMap, switchMap } from 'rxjs/operators';

import { Product } from 'ish-core/models/product/product.model';
import { ProductsService } from 'ish-core/services/products/products.service';
import { personalizationStatusDetermined } from 'ish-core/store/customer/user';
import { loadProductSuccess } from 'ish-core/store/shopping/products';
import { delayUntil, mapErrorToAction, mapToPayload } from 'ish-core/utils/operators';

import {
  loadParametersProductListFilter,
  loadParametersProductListFilterFail,
  loadParametersProductListFilterSuccess,
} from './parameters.actions';

@Injectable()
export class ParametersEffects {
  constructor(
    private actions$: Actions,
    private productsService: ProductsService
  ) {}

  loadParametersProductListFilter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadParametersProductListFilter),
      /* DIAS Customization Start */
      // wait for the PGID - otherwise the list is requested anonymously and ignores the customer segment's catalog views
      delayUntil(this.actions$.pipe(ofType(personalizationStatusDetermined))),
      mapToPayload(),
      groupBy(({ id }) => id),
      mergeMap(group$ =>
        group$.pipe(
          switchMap(({ id, searchParameter, amount }) =>
            this.productsService.getFilteredProducts(searchParameter, amount).pipe(
              mergeMap(({ products }) => [
                ...products.map((product: Product) => loadProductSuccess({ product })),
                loadParametersProductListFilterSuccess({ id, productList: products.map(p => p.sku) }),
              ]),
              mapErrorToAction(loadParametersProductListFilterFail, { id })
            )
          )
        )
      )
      /* DIAS Customization End */
    )
  );
}
